import React from 'react';
import '../styles/BackgroundGenerationBanner.css';

function BackgroundGenerationBanner() {
    return (
        <div className="background-generation-banner">
            <div className="banner-content">
                <div className="banner-pulse-indicator"></div>
                <span className="banner-text">Setting up remaining chapters...</span>
            </div>
        </div>
    );
}

export default BackgroundGenerationBanner;
